import { createSelector } from '@reduxjs/toolkit';
import { SELECTOR, setSelector } from '@socialive/common';
import selectAccountInfo from './selectAccountInfo';

const selectUserEmail = createSelector(selectAccountInfo, (account) => account?.email);

setSelector(SELECTOR.USER_EMAIL, selectUserEmail);

export default selectUserEmail;
